import { render } from "./VisualizarPagamento.vue?vue&type=template&id=7380cc82&scoped=true"
import script from "./VisualizarPagamento.vue?vue&type=script&lang=js"
export * from "./VisualizarPagamento.vue?vue&type=script&lang=js"

import "./VisualizarPagamento.vue?vue&type=style&index=0&id=7380cc82&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7380cc82"]])

export default __exports__